module.exports = __webpack_public_path__ + "img/FILOSOFIA-DANRE.efbfa984.png";